import { DocRenderer, FileLoaderFuncProps } from '@cyntler/react-doc-viewer';
import { ReactNode } from 'react';

const TXTRenderer: DocRenderer = ({ mainState: { currentDocument } }) => {
  return (
    <div className="w-full h-screen p-4 overflow-auto bg-white text-black mt-16">
      {currentDocument?.fileData as ReactNode}
    </div>
  );
};

export default TXTRenderer;

TXTRenderer.fileTypes = ['txt', 'text/plain'];
TXTRenderer.weight = 0;
TXTRenderer.fileLoader = (props: FileLoaderFuncProps) => {
  return fetch(props.documentURI).then(async (res) => {
    const blob = await res.blob();

    const fileReader = new FileReader();
    fileReader.addEventListener('loadend', () =>
      props.fileLoaderComplete(fileReader),
    );
    fileReader.readAsText(blob);
  });
};
